// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-BoxSelector-BoxOption-module__root"};